<div class="w-full bg-sable min-h-screen py-10 px-4">

    <fuse-card class="w-4/5 mx-auto p-8 md:p-12 mb-8 flex flex-col">

        <div class="mb-6">
            <button mat-button type="button" (click)="goToDossiersProjet()"
                matTooltip="Revenir à la liste des dossiers"
                class="!flex items-center hover:!bg-gray-100 cursor-pointer transition-colors">
                <mat-icon class="mr-2 icon-size-5">arrow_back</mat-icon>
                <span>Retour aux dossiers</span>
            </button>
        </div>

        <div class="bg-uploadBg border-l-4 border-accent p-6 mb-10">
            <div class="flex items-start">
                <div class="flex-shrink-0">
                    <mat-icon class="text-accent">info</mat-icon>
                </div>
                <div class="ml-4">
                    <h3 class="text-lg font-bold text-black">{{ isPreparationMode ? 'Commencez votre projet en
                        préparation' : 'Commencez votre projet en déposant le devis' }}</h3>
                    <p class="text-sm text-black mt-1">
                        {{ isPreparationMode
                        ? 'Vous pouvez déposer votre devis même s’il n’est pas encore signé ou s’il s’agit d’un
                        brouillon. Renseignez également les informations du formulaire afin d’initialiser votre projet'
                        : 'Une fois validé par nos équipes, vous pourrez démarrer les travaux et ajouter tous les autres
                        documents de fin de travaux en une fois (facture, attestation sur l’honneur, rapport COFRAC,
                        etc.).' }}
                    </p>
                    <p class="text-sm text-black mt-2 font-medium">
                        Si vous rencontrez un problème, n’hésitez pas à contacter votre Account Manager.<br>
                        L’équipe ACE Energie
                    </p>
                </div>
            </div>
        </div>

        <div class="mb-10" *ngIf="selectedMandataire">
            <mat-form-field appearance="outline" class="w-full md:w-1/3">
                <mat-label>Nom du partenaire</mat-label>
                <mat-select [formControl]="partnersCtrl" (selectionChange)="onPartnerSelected($event)">
                    <input class="p-2" matInput placeholder="Rechercher..." #selectPartner>
                    <mat-option *ngFor="let partner of partnersList | filterEntities: selectPartner?.value ?? ''"
                        [value]="partner">
                        {{partner.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        

        
        <section class="mb-12">
            <h2 class="text-xl font-bold text-gray-800 mb-2">Informations du projet</h2>
            <p class="text-sm text-gray-500 mb-6">
                Le champ « Fin des travaux » est obligatoire pour créer le projet.
            </p>

            <div *ngIf="!isPreparationMode" class="bg-white rounded-xl p-2">
                        <div class="bg-gray-50 border border-gray-200 rounded-2xl p-8 shadow-sm">
                                        <form [formGroup]="projectForm" class="grid grid-cols-1 gap-x-6 gap-y-0">
                                                <div class="w-full flex flex-col gap-4">
                                                    <mat-form-field appearance="outline" class="w-full">
                                                        <mat-label>Fin des travaux (prévue)</mat-label>
                                                        <input matInput [matDatepicker]="picker" formControlName="dateTravauxPrevisionnelle" />
                                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                                        <mat-datepicker #picker></mat-datepicker>
                                                        <mat-error
                                                            *ngIf="projectForm.get('dateTravauxPrevisionnelle')?.hasError('required')">
                                                            Ce champ est obligatoire.
                                                        </mat-error>
                                                    </mat-form-field>

                                                    <mat-form-field appearance="outline" class="w-full">
                                                        <mat-label>Date d’engagement</mat-label>
                                                        <input matInput [matDatepicker]="engagePicker" formControlName="dateEngagement" />
                                                        <mat-datepicker-toggle matSuffix [for]="engagePicker"></mat-datepicker-toggle>
                                                        <mat-datepicker #engagePicker></mat-datepicker>
                                                    </mat-form-field>

                                                    <div class="w-full mt-4">
                                                        <h2 class="text-xl font-bold text-gray-800 mb-2">Opérations du projet</h2>
                                                        <p class="text-sm text-gray-500 mb-3">Sélectionnez l'opération concernée par ce projet.</p>

                                                        <!-- Coup de pouce toggle + visible search field above the select -->
                                                        <div class="mb-3">
                                                            <div class="mb-2 flex items-center gap-3">
                                                                <mat-slide-toggle [(ngModel)]="showCoupDePouce" [ngModelOptions]="{standalone: true}">Coup de pouce</mat-slide-toggle>
                                                            </div>
                                                            <mat-form-field appearance="outline" class="w-full">
                                                                <mat-icon matPrefix>search</mat-icon>
                                                                <input matInput placeholder="Rechercher une opération (ex: BAR-TH-171 - Pompe à chaleur air/eau)..." [(ngModel)]="operationSearchFilter" [ngModelOptions]="{standalone: true}"
                                                                    [matAutocomplete]="opAuto" #operationInput (focus)="openAutocomplete()" (input)="onOperationSearchChange($event.target.value)" autocomplete="off" />
                                                            </mat-form-field>
                                                            <mat-autocomplete #opAuto="matAutocomplete" (optionSelected)="onOperationChosen($event.option.value)" [displayWith]="displayOperation">
                                                                <ng-container *ngFor="let group of groupedOperations">
                                                                    <mat-optgroup *ngIf="filteredOperationsForGroup(group).length > 0" [label]="group.activityName">
                                                                        <mat-option *ngFor="let genericOperation of filteredOperationsForGroup(group)" [value]="genericOperation">
                                                                            <span *ngIf="genericOperation?.ceeOperationFiles?.length > 0">{{ genericOperation.ceeOperationFiles[0].name }} :</span>
                                                                            {{ genericOperation.label }}
                                                                        </mat-option>
                                                                    </mat-optgroup>
                                                                </ng-container>
                                                            </mat-autocomplete>
                                                        </div>
                                                        <!-- Selected operations list -->
                                                        <div class="grid gap-3 mt-3">
                                                            <div *ngFor="let operation of selectedOperations; let i = index" class="flex items-center justify-between bg-white border border-gray-200 rounded-lg px-4 py-3">
                                                                <div class="flex items-center gap-3">
                                                                    <div class="w-10 h-10 flex items-center justify-center rounded bg-gray-100 text-teal-600">
                                                                        <mat-icon [svgIcon]="'heroicons_outline:document-text'" class="h-10 w-10 text-accent"></mat-icon>
                                                                    </div>
                                                                    <div>
                                                                        <div class="font-bold">{{ operation.ceeOperationFiles && operation.ceeOperationFiles[0]?.name }}</div>
                                                                        <div class="text-sm text-gray-600">{{ operation.label }}</div>
                                                                    </div>
                                                                </div>
                                                                <button type="button" (click)="removeSelectedOperation(i)">
                                                                    <mat-icon [svgIcon]="'heroicons_outline:trash'" class="h-6 w-6 text-red-600"></mat-icon>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                        </form>
                                </div>
            </div>
            <div *ngIf="isPreparationMode" class="bg-white rounded-xl p-2">
                <div class="bg-gray-50 border border-gray-200 rounded-2xl p-8 shadow-sm">
                    <form [formGroup]="projectForm" class="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-0">

                        <mat-form-field appearance="outline" class="w-ful">
                            <mat-label>Raison sociale du bénéficiaire</mat-label>
                            <input matInput formControlName="rs" class="rounded-md" />
                            <mat-icon matSuffix>business</mat-icon>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Nom du bénéficiaire</mat-label>
                            <input matInput formControlName="nom" />
                            <mat-icon matSuffix>person</mat-icon>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Prénom du bénéficiaire</mat-label>
                            <input matInput formControlName="prenom" />
                            <mat-icon matSuffix>person</mat-icon>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Email</mat-label>
                            <input matInput formControlName="email" type="email" />
                            <mat-icon matSuffix>email</mat-icon>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Fin des travaux (prévue)</mat-label>
                            <input matInput [matDatepicker]="picker" formControlName="dateTravauxPrevisionnelle" />
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                            <mat-error
                                *ngIf="projectForm.get('dateTravauxPrevisionnelle')?.hasError('required')">
                                Ce champ est obligatoire.
                            </mat-error>
                            <mat-hint>Le champ « Fin des travaux » est obligatoire pour créer le projet.</mat-hint>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Date d’engagement</mat-label>
                            <input matInput [matDatepicker]="engagePicker" formControlName="dateEngagement" />
                            <mat-datepicker-toggle matSuffix [for]="engagePicker"></mat-datepicker-toggle>
                            <mat-datepicker #engagePicker></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="col-span-1 md:col-span-3 w-full">
                            <mat-label>Adresse postale</mat-label>
                            <input formControlName="adresse" matInput [matAutocomplete]="auto"
                                (click)="showAdressAutocomplete()">
                            <mat-icon matSuffix>location_on</mat-icon>
                            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedOption($event)">
                                <mat-option *ngFor="let option of filteredOptions?.features" [value]="option">
                                    {{option.properties.label}}, France
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Code postal</mat-label>
                            <input matInput formControlName="cp" />
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Ville</mat-label>
                            <input matInput formControlName="ville" />
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Téléphone</mat-label>
                            <input matInput formControlName="tel" />
                            <mat-icon matSuffix>phone</mat-icon>
                        </mat-form-field>
                    </form>
                </div>
            </div>

            <p class="text-sm text-gray-500 mb-6">{{ isPreparationMode ? 'Veuillez télécharger votre devis pour
                initialiser votre projet' : 'Veuillez déposer votre devis pour initialiser votre projet.' }}</p>

            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
                <div *ngFor="let card of cards">
                    <app-card-upload [card]="card" (viewFile)="onViewFile($event)"
                        (fileSelected)="onFileSelected($event)">
                    </app-card-upload>
                </div>
            </div>

            
            <!-- Cards display Section -->
            <div class="w-full flex flex-wrap justify-center gap-4 items-start">
                <div class="w-full flex flex-wrap justify-center gap-4 items-start max-h-[410px] overflow-auto py-2">

                    <!-- Single file cards (up to 3) -->
                    <ng-container *ngIf="getSingleFileCard().length > 0">
                        <app-file-card *ngFor="let file of getSingleFileCard(); let i = index" [cardName]="file.card"
                            [file]="file.files[0]" [fileName]="file.files[0].name"
                            (fileDeleted)="onFileDeleted($event)"></app-file-card>
                    </ng-container>

                    <!-- Multi-file card (4th card slot) -->
                    <ng-container *ngIf="getMultipleFileCard().length > 0">
                        <ng-container *ngIf="getMultipleFileCard().length > 0 as multiCards">
                            <ng-container *ngIf="getMultipleFileCard()[0] as multi">
                                <ng-container *ngFor="let file of multi.files; let i = index">
                                    <app-file-card [cardName]="multi.card"
                                        [fileName]="file.name" [file]="file"
                                        (fileDeleted)="onFileDeleted($event)"></app-file-card>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </section>

        <div *ngIf="fileValidationMessages.length > 0"
            class="mb-6 rounded-lg border border-red-200 bg-red-50 px-4 py-3">
            <p class="text-sm font-semibold text-red-700 mb-2">Certains fichiers doivent être corrigés avant le dépôt :
            </p>
            <ul class="list-disc pl-5 space-y-1">
                <li *ngFor="let message of fileValidationMessages" class="text-sm text-red-600">
                    {{ message }}
                </li>
            </ul>
        </div>        

        <div class="flex justify-center border-t border-gray-100 pt-8">
            <button (click)="deposeProjectFinancement()" [matTooltip]="getSubmitTooltip()"
                [disabled]="projectForm.invalid || isUploadDisabled() || isUploading || (selectedMandataire && !selectedPartnerByMandate) || (!isPreparationMode && selectedOperations.length === 0)"
                class="bg-[#419a8c] hover:bg-[#357d72] text-white font-bold py-3 px-10 rounded-lg transition-colors shadow-md disabled:opacity-50 inline-flex items-center justify-center">
                <mat-icon svgIcon="send" class="mr-2 !flex items-center justify-center text-white">
                </mat-icon>

                <span>{{ isPreparationMode ? 'Créer le projet' : 'Déposer un devis' }}</span>
            </button>
        </div>
    </fuse-card>

    <div class="w-4/5 mx-auto" *ngIf="isUploading">
            <!-- Replaced the submit button with an analysis progress component that receives progress -->
            <app-creation-analysis-progress class="w-full" [progressPercent]="draftProgressPercent" [statusMessage]="draftProgressMessage"></app-creation-analysis-progress>
        </div>

    <app-project-display-history [rawItems]="rawItems" [showPartnerName]="!selectedPartnerByMandate">
    </app-project-display-history>
</div>